import { render, staticRenderFns } from "./OccupantLoadFactorList.vue?vue&type=template&id=11964d9a&"
import script from "./OccupantLoadFactorList.vue?vue&type=script&lang=js&"
export * from "./OccupantLoadFactorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports